export { BottomBarShopEntityMobile } from './bottom-bar-shop';
